import { AdminModuleKey, AppRole } from '../types';

export const APP_ROLES: AppRole[] = [
  'SuperAdmin',
  'Content-Manager',
  'Data-Analyst',
];

export const MODULE_ACTIONS: Record<AdminModuleKey, string[]> = {
  overview: ['view'],
  users: ['view', 'activate', 'deactivate', 'suspend', 'assignRoles'],
  points: ['view', 'lookup', 'history', 'mockDonation'],
  circles: ['view', 'edit', 'delete'],
  causes: ['view', 'create', 'edit', 'publish', 'archive', 'delete'],
  challenges: ['view', 'create', 'edit', 'delete'],
  content: ['view', 'create', 'edit', 'featureControl', 'delete'],
  reporting: ['view', 'export'],
  settings: ['view', 'edit'],
  roles: ['view', 'manage'],
  streaks: ['view', 'approve', 'reject', 'delete'],
  donationTracking: ['view', 'update', 'export'],
  notifications: ['view', 'create', 'schedule', 'cancel', 'analytics'],
};

export const ROLE_PERMISSION_MATRIX: Record<
  AppRole,
  Partial<Record<AdminModuleKey, string[]>>
> = {
  SuperAdmin: {
    overview: ['view'],
    users: MODULE_ACTIONS.users,
    points: MODULE_ACTIONS.points,
    circles: MODULE_ACTIONS.circles,
    causes: MODULE_ACTIONS.causes,
    challenges: MODULE_ACTIONS.challenges,
    content: MODULE_ACTIONS.content,
    reporting: MODULE_ACTIONS.reporting,
    settings: MODULE_ACTIONS.settings,
    roles: MODULE_ACTIONS.roles,
    streaks: MODULE_ACTIONS.streaks,
    donationTracking: MODULE_ACTIONS.donationTracking,
    notifications: MODULE_ACTIONS.notifications,
  },
  'Content-Manager': {
    overview: ['view'],
    users: ['view'],
    points: MODULE_ACTIONS.points,
    circles: ['view', 'edit'],
    causes: ['view', 'create', 'edit', 'publish', 'archive'],
    challenges: ['view', 'create', 'edit'],
    content: ['view', 'create', 'edit', 'featureControl'],
    reporting: ['view', 'export'],
    settings: ['view'],
    roles: ['view'],
    streaks: ['view', 'approve', 'reject'],
    donationTracking: ['view', 'update'],
    notifications: ['view', 'create', 'schedule', 'cancel', 'analytics'],
  },
  'Data-Analyst': {
    overview: ['view'],
    users: ['view'],
    points: ['view', 'lookup', 'history'],
    circles: ['view'],
    causes: ['view'],
    challenges: ['view'],
    content: ['view'],
    reporting: ['view', 'export'],
    settings: ['view'],
    roles: ['view'],
    streaks: ['view'],
    donationTracking: ['view', 'export'],
    notifications: ['view', 'analytics'],
  },
};

export const ROLE_DESCRIPTIONS: Record<AppRole, string> = {
  SuperAdmin: 'Full administrative control across the platform.',
  'Content-Manager':
    'Manages content, causes, publishing workflows, and feature visibility.',
  'Data-Analyst':
    'Read-heavy access for analytics, exports, monitoring, and audit review.',
};

export const hasRequiredRole = (
  role: string | null | undefined,
  allowedRoles?: AppRole[]
) => {
  if (!allowedRoles || allowedRoles.length === 0) {
    return true;
  }

  if (!role) {
    return false;
  }

  return allowedRoles.includes(role as AppRole);
};

export const canRoleAccessModule = (
  role: AppRole,
  moduleKey: AdminModuleKey,
  action = 'view'
) => {
  return ROLE_PERMISSION_MATRIX[role]?.[moduleKey]?.includes(action) ?? false;
};
